import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { StyledDndItem, NoLineItemWrapper } from "./styles";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const Item = ({ item, index }) => (
  <Draggable draggableId={`${item.id}`} index={index} key={`draggable-${item.id}`}>
    {provided => (
      <StyledDndItem ref={provided.innerRef} {...provided.draggableProps}>
        {React.cloneElement(item.content, { handleProps: provided.dragHandleProps })}
      </StyledDndItem>
    )}
  </Draggable>
);

const ItemsList = ({ items }) => {
  if (!items.length) {
    return <NoLineItemWrapper>None Selected</NoLineItemWrapper>;
  }

  return items.map((item, index) => <Item item={item} index={index} key={item.id} />);
};

const DndContainer = props => {
  const [itemsList, setItemsList] = useState(props.items);

  useEffect(() => {
    setItemsList(props.items);
  }, [props]);

  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const items = reorder(itemsList, result.source.index, result.destination.index);
    if (props.saveOrderChange) {
      props.saveOrderChange(items);
    }

    setItemsList(items);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <ItemsList items={itemsList} />
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DndContainer;
